<div class="qa-mapping-builder">
  <div class="qa-mapping-side">
    <span class="qa-field-label">{{_(KEYS.EDITOR.SOURCE)}}</span>
    <div class="qa-mapping-selects">
      <select class="form-control qa-custom-select" [(ngModel)]="sourceScope" [attr.aria-label]="_(KEYS.EDITOR.SOURCE)">
        <ng-container *ngFor="let scopeName of scopeNames">
          <option value="{{scopeName}}" *ngIf="isAllowedSourceScope(scopeName)">{{_(variableScopes[scopeName].name)}}</option>
        </ng-container>
      </select>
      <select class="form-control qa-custom-select" [(ngModel)]="sourceVariable">
        <ng-container *ngIf="sourceScope && variableScopes[sourceScope]">
          <ng-container *ngIf="variableScopes[sourceScope].mappings; else noSourceMappingVar">
            <option
              value="{{variableScopes[sourceScope].mappings[key]}}"
              *ngFor="let key of getObjectKeys(variableScopes[sourceScope].mappings)"
            >
              {{key}}
            </option>
          </ng-container>
        </ng-container>
        <ng-template #noSourceMappingVar>
          <option *ngFor="let varName of getVariablesForScope(sourceScope)" value="{{varName}}">{{varName}}</option>
        </ng-template>
      </select>
    </div>
  </div>

  <i class="fa fa-long-arrow-right qa-mapping-arrow" aria-hidden="true"></i>

  <div class="qa-mapping-side">
    <span class="qa-field-label">{{_(KEYS.EDITOR.TARGET)}}</span>
    <div class="qa-mapping-selects">
      <select class="form-control qa-custom-select" [(ngModel)]="targetScope" [attr.aria-label]="_(KEYS.EDITOR.TARGET)">
        <ng-container *ngFor="let scopeName of scopeNames">
          <option value="{{scopeName}}" *ngIf="isAllowedTargetScope(scopeName)">{{variableScopes[scopeName].name}}</option>
        </ng-container>
      </select>
      <select class="form-control qa-custom-select" [(ngModel)]="targetVariable">
        <ng-container *ngIf="targetScope && variableScopes[targetScope]">
          <ng-container *ngIf="variableScopes[targetScope].mappings; else noTargetMappingVar">
            <option
              value="{{variableScopes[targetScope].mappings[key]}}"
              *ngFor="let key of getObjectKeys(variableScopes[targetScope].mappings)"
            >
              {{key}}
            </option>
          </ng-container>
        </ng-container>
        <ng-template #noTargetMappingVar>
          <option *ngFor="let varName of getVariablesForScope(targetScope)" value="{{varName}}">{{varName}}</option>
        </ng-template>
      </select>
    </div>
  </div>

  <button type="button" class="qa-icon-btn qa-icon-btn-save qa-mapping-add" [attr.disabled]="canAdd() ? null : true" (click)="onAdd()">
    <i class="fa fa-plus" aria-hidden="true"></i>
  </button>
</div>

<div class="qa-mapping-list" *ngIf="questionnaire.meta.options.variablesMapping?.length">
  <ng-container *ngFor="let mapping of questionnaire.meta.options.variablesMapping; let pos = index">
    <div class="qa-mapping-row" *ngIf="isValidMapping(mapping)">
      <span class="qa-mapping-ref">
        <span class="qa-mapping-scope">{{_(formatScopeName(mapping.source.scope))}}</span>
        {{formatVarName(mapping.source.variable)}}
      </span>
      <i class="fa fa-long-arrow-right qa-mapping-arrow" aria-hidden="true"></i>
      <span class="qa-mapping-ref">
        <span class="qa-mapping-scope">{{_(formatScopeName(mapping.target.scope))}}</span>
        {{formatVarName(mapping.target.variable)}}
      </span>
      <button type="button" class="qa-icon-btn qa-icon-btn-danger" (click)="onDelete(pos)">
        <i class="fa fa-trash" aria-hidden="true"></i>
      </button>
    </div>
  </ng-container>
</div>
